import React, { useEffect, useState } from "react";
import ParticipantCard from "./ParticipantCard";
import "../../css/ParticipantsForm.css";
import Toggle from "./Toggle";
import ErrorPopup from "./ErrorPopup";
const ParticipantsForm = ({ data, onNext }) => {
  const [errorMessage, setErrorMessage] = useState("");
    useEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);
  const config = data.config;
const [formData, setFormData] = useState(data);

  const handleParticipantChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      participants: prev.participants.map((p, i) =>
        i === index ? { ...p, [field]: value } : p
      ),
    }));
  };

  const getAge = (birthDateString) => {
    const today = new Date();
    const birthDate = new Date(birthDateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleInsuranceChange = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      participants: prev.participants.map((p, i) =>
        i === index ? 
          (p.insurance ?
            { ...p, insurance: { ...p.insurance, [field]: value } } :
           {...p, insurance: {[field]: value}})
          : p
      ),
    }));
  };

  const handleNnwInsuranceChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      nnwInsurance: value,
      krInsurance: value ? prev.krInsurance : false,
      participants: prev.participants.map((p) => ({
        ...p,
        insurance: value
          ? { firstName: "", lastName: "", birthDate: "", isChronicIllness: false } 
          : undefined, 
      })),
    }));
  };
  

  const handleKrInsurance = (value) => {
    setFormData((prev) => ({
      ...prev,
      krInsurance : value
    }));
  }
  

  const handleAdditionalInfoChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      additionalInfo: { ...prev.additionalInfo, [field]: value },
    }));
  };

  const handleCanTakePassangers = (value) => {
    handleAdditionalInfoChange("canTakePassengers", value);
    if(!value)
    {
      handleAdditionalInfoChange("passengerCount", "");
    }
  }

  const handleHasCar = (value) =>{
    handleAdditionalInfoChange("hasCar", value);
    if(!value) {
      handleCanTakePassangers(false);
    }
  }

  const validateAdults = () => {
    const hasUnset = formData.participants.some(
      (p) => typeof p.isAdult !== "boolean"
    );
  
    if (hasUnset) {
      setErrorMessage("Każda osoba uczestnicząca musi być osobą pełnoletnią. Upewnij się, że deklaracja ta została zaznaczona przy każdej osobie.");
      return false;
    }
  
    const allAdults = formData.participants.every((p) => p.isAdult === true);
  
    if (!allAdults) {
      setErrorMessage("W wydarzeniu mogą brać udział wyłącznie osoby pełnoletnie. Upewnij się, że przy każdej osobie uczestniczącej zaznaczyłxś, że jest to osoba pełnoletnia.");
      return false;
    }
  
    const hasUnderageByDate = formData.participants.some((p) => {
      if (!p.insurance || !p.insurance.birthDate) return false;
      return getAge(p.insurance.birthDate) < 18;
    });
  
    if (hasUnderageByDate) {
      setErrorMessage("Co najmniej jedna data urodzenia wskazuje na osobę niepełnoletnią. Tylko osoby pełnoletnie mogą brać udział w wydarzeniach.");
      return false;
    }
  
    return true;
  };

  const validateFormData = () => {
    if (!formData.participants || formData.participants.length === 0) {
      setErrorMessage("Rezerwacja musi zawierać co najmniej jedną osobę uczestniczącą.");
      return false;
    }

     const phoneNumbers = new Set();

    for (const participant of formData.participants) {
      if (!participant.preferredName?.trim()) {
        setErrorMessage("Każda osoba uczestnicząca musi mieć podane imię.");
        return false;
      }

      const nameParts = participant.preferredName.trim().split(/\s+/);
      if (nameParts.length < 2) {
        setErrorMessage(`Imię i nazwisko osoby ${participant.preferredName} musi zawierać co najmniej dwa wyrazy (np. "Jan Kowalski").`);
        return false;
      }


      const emailRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
      if (!participant.email || !emailRegex.test(participant.email)) {
        setErrorMessage(`Nieprawidłowy adres e-mail osoby ${participant.preferredName}.`);
        return false;
      }
      const phoneRegex = /^\+?[0-9 ]{9,15}$/;
      if (!participant.phone || !phoneRegex.test(participant.phone)) {
        setErrorMessage(`Nieprawidłowy numer telefonu osoby ${participant.preferredName}.`);
        return false;
      }

      if (phoneNumbers.has(participant.phone)) {
        setErrorMessage(`Numer telefonu ${participant.phone} został użyty więcej niż raz. Każda osoba uczestnicząca musi mieć unikalny numer telefonu.`);
        return false;
      }
      phoneNumbers.add(participant.phone);

      if (participant.insurance) {
        if (!participant.insurance.firstName || !participant.insurance.lastName || !participant.insurance.birthDate) {
          setErrorMessage(`Dane ubezpieczenia dla osoby ${participant.preferredName} są niekompletne.`);
          return false;
        }
      }
    }

    if (!formData.additionalInfo?.departureCity?.trim()) {
      setErrorMessage("Miejscowość wyjazdu jest obowiązkowa.");
      return false;
    }

    if (formData.additionalInfo.canTakePassengers && (!formData.additionalInfo.passengerCount || formData.additionalInfo.passengerCount <= 0)) {
      setErrorMessage("Liczba dodatkowych miejsc dla osób pasażerskich musi być większa od 0.");
      return false;
    }
    return true;
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateAdults()) return;
    if (!validateFormData()) return;

    if (!e.target.checkValidity()) {
      e.target.reportValidity();
      return;
    } else {
    onNext({ ...formData, isTouristEvent: config.isTouristEvent });
    }
  };

  return (
    <div className="participants-form-container">

      <div className="form-box">
           <h2>Formularz rejestracyjny</h2>
          <div className="form-info time-warning">
            Aby ukończyć rezerwację, uzupełnij formularz jak najszybciej – po 30 minutach nieuzupełnione rezerwacje są automatycznie usuwane.
          </div>
           <div className="global-settings">
            <div className="form-group">
                <span>
                  {config.nnwRequired ? 
                     "Ubezpieczenie NNW jest wymagane dla wszystkich osób uczestniczących." 
                    : (config.nnwRequired === false) &&  <Toggle label="Czy chcesz wykupić ubezpieczenie NNW dla wszystkich osób uczestniczących?" 
                                                                checked={formData.nnwInsurance ?? false}
                                                                onChange={(e) => handleNnwInsuranceChange(e.target.checked)}/>}
                </span>
            </div>

            { (config.nnwRequired || formData.nnwInsurance)&& <div className="form-group">
              <Toggle label="Czy chcesz wykupić ubezpieczenie od kosztów rezygnacji?" 
                    checked={formData.krInsurance ?? false}
                    onChange={(e) => handleKrInsurance(e.target.checked)}/>
            </div>
            }
          </div>
        <form onSubmit={handleSubmit}>

          {formData.participants.map((participant, index) => (
            <ParticipantCard
              key={index}
              index={index}
              isMain={index === 0}
              data={participant}
              onChange={(field, value) =>
                handleParticipantChange(index, field, value)
              }
              onInsuranceChange={(field, value) =>
                handleInsuranceChange(index, field, value)
              }
              showNNWInsurance={config.nnwRequired || formData.nnwInsurance}
            />
          ))}

          <div className="form-section city-section">
            <h3>Miejsce wyjazdu</h3>
            <div className="form-group">
              <label>Miejscowość *</label>
              <input
                type="text"
                placeholder="Podaj miejscowość"
                value={formData.additionalInfo.departureCity || ""}
                onChange={(e) =>
                  handleAdditionalInfoChange("departureCity", e.target.value)
                }
                required
              />
            </div>
            <div className="form-group">
              <label>Dodatkowe informacje</label>
              <input
                type="text"
                placeholder="Dodatkowe informacje (okolica, dzielnica)"
                value={formData.additionalInfo.departureCityInfo || ""}
                onChange={(e) =>
                  handleAdditionalInfoChange(
                    "departureCityInfo",
                    e.target.value
                  )
                }
              />
            </div>
          </div>

          {config.askAboutCars && <div className="form-section transport-section">
            <h3>Dojazd</h3>
            <div className="form-group">
              <Toggle label="Czy na miejsce zbiórki zamierzasz dotrzeć własnym samochodem?" 
                    checked={formData.additionalInfo.hasCar}
                    onChange={(e) => handleHasCar(e.target.checked)}/>
            </div>
            {formData.additionalInfo.hasCar && (
              <>
                <div className="form-group">
                <Toggle label="Czy możesz zabrać inne osoby pasażerskie?" 
                    checked={formData.additionalInfo.canTakePassengers}
                    onChange={(e) => handleCanTakePassangers(e.target.checked)}/>
                </div>
                {formData.additionalInfo.canTakePassengers && (
                  <div className="form-group">
                           {formData.additionalInfo.canTakePassengers && (
                  <div className="form-group">
                    <label>Liczba osób możliwych do zabrania</label>
                    <input
                      type="number"
                      placeholder="Podaj liczbę dodatkowych miejsc"
                      value={formData.additionalInfo.passengerCount || ""}
                      step={1}
                      min={1}
                      onChange={(e) =>
                        handleAdditionalInfoChange(
                          "passengerCount",
                          e.target.value
                        )
                      }
                    />
                  </div>
                )}

                  </div>
                )}
              </>
            )}
          </div>
          }

          {config.askAboutPets && 
          <div className="form-section pets-section">
            <h3>Zwierzęta</h3>
            <p className="pets-section-p">{config.petsInfo}</p>
            <div className="form-group">
              <div className="form-group-span">
              <Toggle label="Czy zabierasz ze sobą zwierzaka?" 
                    checked={formData.additionalInfo.hasPet}
                    onChange={(e) => {
                    handleAdditionalInfoChange("hasPet", e.target.checked);
                    handleAdditionalInfoChange("petInfo", "");
                    }}/>
             </div>
            </div>
            {formData.additionalInfo.hasPet && (
              <div className="form-group">
                <label>Informacje o zwierzęciu</label>
                <textarea
                  placeholder="Podaj informacje o zwierzęciu"
                  value={formData.additionalInfo.petInfo || ""}
                  onChange={(e) =>
                    handleAdditionalInfoChange("petInfo", e.target.value)
                  }
                ></textarea>
              </div>
            )}
          </div>}

          { config.askAboutFoodOptions && 
            <div className="form-section pets-section">
            <h3>Wyżywienie</h3>
            <div className="form-group">
                <label>{config.foodInfo}</label>
                <textarea
                  value={formData.additionalInfo.foodInfo|| ""}
                  onChange={(e) =>
                    handleAdditionalInfoChange("foodInfo", e.target.value)
                  }
                ></textarea>
              </div>
          </div>
          }

          <div className="form-section pets-section">
            <h3>Pytania i komentarze</h3>
            <div className="form-group">
                <label>Miejsce na dodatkowe pytania i informacje. W razie potrzeby osoba koordynatorska skontaktuje sie z Tobą!</label>
                <textarea
                  value={formData.additionalInfo.userComment|| ""}
                  onChange={(e) =>
                    handleAdditionalInfoChange("userComment", e.target.value)
                  }
                ></textarea>
              </div>
          </div>

          <button type="submit" className="submit-button">
            Podsumowanie
          </button>
        </form>
      </div>
      {errorMessage && ( <ErrorPopup message={errorMessage} onClose={() => setErrorMessage("")} />

)}
    </div>
  );
};

export default ParticipantsForm;
